import React, { useEffect } from 'react';

const PricingCancel = () => {
    // Notify parent window if in iframe
    useEffect(() => {
        window.parent.postMessage({
            type: 'PAYMENT_CANCELLED'
        }, '*');
    }, []);

    return (
        <div className="min-h-screen bg-[#1E2330] flex items-center justify-center p-4">
            <div className="max-w-md mx-auto text-center text-white">
                <div className="w-16 h-16 bg-yellow-600 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                </div>
                <h2 className="text-2xl font-bold mb-2">Bestilling avbrutt</h2>
                <p className="text-[#E0E0E0] mb-6">
                    Du avbrøt betalingsprosessen. Ingen betaling ble gjennomført.
                </p>
                <button
                    onClick={() => window.history.back()}
                    className="px-6 py-3 bg-[#FFD700] text-[#1E2330] font-bold rounded-full hover:bg-yellow-400 transition-colors"
                >
                    Tilbake til priser
                </button>
            </div>
        </div>
    );
};

export default PricingCancel;